import { createComponent } from '@carvana/merch-components';

export const Aside = createComponent('aside', {
  className: `
    bg-white
    border
    border-grey-2
    h-fit
    hidden
    max-h-[calc(100vh-48px)]
    overflow-y-auto
    rounded-[6px]
    sticky
    top-[32px]
    w-full
    l:block`
});
